import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import HowTo from './components/HowTo';
import Comparison from './components/Comparison';
import Faq, { FAQS } from './components/Faq';
import Footer from './components/Footer';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowTo />
        <Comparison />
        <Faq />
      </main>
      <Footer />
    </>
  );
}